"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupplierCommentAttachment = void 0;
const typeorm_1 = require("typeorm");
// eslint-disable-next-line import/no-cycle
const SupplierAttachment_1 = require("./SupplierAttachment");
// eslint-disable-next-line import/no-cycle
const User_1 = require("../../user/entity/User");
let SupplierCommentAttachment = class SupplierCommentAttachment extends SupplierAttachment_1.SupplierAttachment {
    constructor(init) {
        super();
        if (init) {
            Object.assign(this, init);
        }
    }
};
exports.SupplierCommentAttachment = SupplierCommentAttachment;
__decorate([
    (0, typeorm_1.ManyToOne)(() => User_1.User),
    __metadata("design:type", User_1.User)
], SupplierCommentAttachment.prototype, "author", void 0);
__decorate([
    (0, typeorm_1.RelationId)((a) => a.author),
    __metadata("design:type", String)
], SupplierCommentAttachment.prototype, "authorId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], SupplierCommentAttachment.prototype, "comment", void 0);
exports.SupplierCommentAttachment = SupplierCommentAttachment = __decorate([
    (0, typeorm_1.ChildEntity)('comment'),
    __metadata("design:paramtypes", [Object])
], SupplierCommentAttachment);
